import { useFlagContext } from "./FlagProvider";
import type { DeliveryFlagKey } from "./constants";

/**
 * Evaluates a feature flag using the FlagProvider context.
 * Returns `false` while flags are loading or if outside a FlagProvider.
 */
export function useFeatureFlag(flagKey: DeliveryFlagKey): boolean {
  const { evaluate } = useFlagContext();
  return evaluate(flagKey);
}
